// src/contexts/NotificationContext.js
// Version: 1.0.0
import { createContext } from 'react';

export const NotificationContext = createContext(null);
